import { useEffect, useState } from "react";
import UpdateProductionPlanDetails from "./UpdateProductionPlanDetails";
import PlanSetup from "./PlanSetup";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";
import { fetchDishes } from "../../services/getcategorySlice";
import { fetchAllReasons } from "../../services/updateProductionPlanSlice";

const UpdateProductionPlan = () => {
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();
  const [open, setOpen] = useState<boolean>(false);
  const userId = localStorage.getItem('userid');
  const handleClick = (): void => {
      setOpen(true);
  };  
  const handleFilterChange = (): void => {
    setOpen(false);
  };  

  useEffect(() => {
    dispatch(fetchDishes({ sitelistid:[], userid: userId}));
    dispatch(fetchAllReasons());
  }, []);

  return (
    <div className="content-wrapper">
      <h1 className="flex align-items-center">
        Update Production Plan
      </h1>
      <PlanSetup handleClick={handleClick} handleFilterChange={handleFilterChange}/>
      {open && 
        <UpdateProductionPlanDetails />
      }      
    </div>    
  );
};

export default UpdateProductionPlan;
